import { combineReducers } from 'redux';
import { MODE_SOLUTION, TYPE_THEMATIQUE } from '../constants';
import {
  FETCH_EXAM_PENDING,
  FETCH_EXAM_FULFILLED,
  FETCH_EXAM_REJECTED,
  SAVE_EXAM_PENDING,
  SAVE_EXAM_FULFILLED,
  SAVE_EXAM_REJECTED,
  GOTO_QUESTION,
  NEXT_QUESTION,
  PREV_QUESTION,
  SELECT_ANSWER,
  DESELECT_ANSWER,
  CLEAR_SELECTION,
  CONFIRM_SELECTION,
  TOGGLE_SPLASHSCREEN,
  TOGGLE_COMMENTS,
  TOGGLE_SOLUTION,
  TOGGLE_FULLSCREEN,
  TOGGLE_IMAGE_FULLSCREEN,
  TOGGLE_SOUND,
  TOGGLE_PAUSE_REJECTED,
  TOGGLE_PAUSE_FULFILLED,
  AUDIO_START,
  AUDIO_STOP,
  DISPLAY_AUDIO,
  START_TIMER,
  DECREMENT_TIMER, checkQuestionIsValid
} from '../actions/exam';

const initialState = {
  api: {
    getExamUrl: null,
    postExamUrl: null,
    imagesUrl: null,
    iconsUrl: null,
    audioUrl: null
  },
  userId: null,
  testId: null,
  testNumber: null,
  testSlug: null,
  categoryId: null,
  categories: [],
  questions: [],
  currentQuestion: null,
  totalTime: 0,
  timeLeft: 0,
  timeLeftTimer: null,
  selected: [],
  choices: [],
  audio: null,
  displayAudio: true,
  mode: null,
  type: null,
  max: null, // Max number of errors. "m" = you need to get the average on each category.
  showSplashScreen: true,
  showComments: false,
  showSolution: false,
  fullscreen: false,
  imageFullscreen: false,
  sound: false,
  pause: false,
  loading: true,
  error: null
};

function exam(state = initialState, action) {
  switch (action.type) {
    case FETCH_EXAM_PENDING:
      return {...state, loading: true};
    case FETCH_EXAM_FULFILLED:
      const dev = process.env.NODE_ENV === 'development';
      const modeSolution = action.payload.mode === MODE_SOLUTION;
      const postExamUrl = dev ? process.env.REACT_APP_API_URL_POST_EXAM : action.payload.url_enregistrement;
      const imagesUrl = action.payload.url_photos;
      const iconsUrl = action.payload.url_icones;
      const audioUrl = action.payload.url_sons;

      let choices = action.payload.choices;
      if (modeSolution) {
        choices = choices.map((choice, index) => checkQuestionIsValid(action.payload.items[index], choice));
        state.categories.map(cat => {
          if(cat.code === state.questions[state.currentQuestion].cat) {
            return {
              ...cat,
              score: cat.score + (choice.valid ? 1 : 0),
              total: cat.total + 1
            }
          }
          return cat;
        })
      }

      // Convert categories object to array of objects
      const categories = Object.entries(action.payload.cats)
        .map(cat => {
          let currentCat = { code: cat[0], name: cat[1], score: 0, total: 0 };
          // If solution mode, calculate score per category
          if (modeSolution) {
            for (let i = 0; i < action.payload.items.length; i++) {
              const question = action.payload.items[i];
              const choice = choices[i];
              if (currentCat.code === question.cat) {
                currentCat.total++;
                currentCat.score = currentCat.score + (choice.valid ? 1 : 0)
              }
            }
          }
          return currentCat;
        })
        .sort((a, b) => {
          if (a.code > b.code) {
            return 1;
          } else if (a.code < b.code) {
            return -1;
          }
          return 0;
        })
      ;

      return {
        ...state,
        api: {...state.api, postExamUrl: postExamUrl, imagesUrl: imagesUrl, iconsUrl: iconsUrl, audioUrl: audioUrl},
        userId: action.payload.identifiant,
        testId: action.payload.id_questionnaire,
        testNumber: action.payload.id_candidat,
        testSlug: action.payload.identifiant,
        categoryId: action.payload.categorie,
        categories: categories,
        questions: action.payload.items,
        choices: choices ? choices : [],
        totalTime: action.payload.temps,
        timeLeft: action.payload.temps,
        mode: action.payload.mode,
        type: action.payload.type,
        max: action.payload.max,
        currentQuestion: modeSolution ? null : 0,
        loading: false
      };
    case FETCH_EXAM_REJECTED:
      return {...state, error: true};
    case SAVE_EXAM_PENDING:
      return {...state, loading: true};
    case SAVE_EXAM_FULFILLED:
      return {...state, loading: false};
    case SAVE_EXAM_REJECTED:
      console.log(action.payload);
      return {...state, error: true};
    case START_TIMER:
      return {...state, timeLeftTimer: action.payload};
    case DECREMENT_TIMER:
      if (state.timeLeft > 0) {
        return {...state, timeLeft: state.timeLeft - 1};
      }
      break;
    case GOTO_QUESTION:
      clearInterval(state.timeLeftTimer);
      return {...state, currentQuestion: action.payload, timeLeft: state.totalTime, timeLeftTimer: null, showComments: false, showSolution: false};
    case NEXT_QUESTION:
      clearInterval(state.timeLeftTimer);
      const currentQuestion = state.currentQuestion + 1;
      // Check if the test is finished
      if (currentQuestion === state.questions.length) {
        return {...state, currentQuestion: null, mode: MODE_SOLUTION};
      } else {
        return {...state, currentQuestion: currentQuestion, timeLeft: state.totalTime, timeLeftTimer: null, showComments: false, showSolution: false};
      }
    case PREV_QUESTION:
      clearInterval(state.timeLeftTimer);
      return {...state, currentQuestion: state.currentQuestion - 1, timeLeft: state.totalTime, timeLeftTimer: null, showComments: false, showSolution: false};
    case SELECT_ANSWER:
      if (!state.selected.includes(action.payload)) {
        return {...state, selected: [...state.selected, action.payload]};
      }
      break;
    case DESELECT_ANSWER:
      return {...state, selected: state.selected.filter(a => a !== action.payload)};
    case CLEAR_SELECTION:
      return {...state, selected: []};
    case CONFIRM_SELECTION:
      let choice = {
        values: state.selected,
        missing: state.questions[state.currentQuestion].questions.flatMap(q => q.reponses).reduce((missing, r) => r.correcte && !state.selected.includes(r.lettre) ? [...missing, r.lettre] : missing, []),
        wrong: state.questions[state.currentQuestion].questions.flatMap(q => q.reponses).reduce((wrong, r) => !r.correcte && state.selected.includes(r.lettre) ? [...wrong, r.lettre] : wrong, [])
      }
      choice.valid = choice.missing.length === 0 && choice.wrong.length === 0;
      return {
        ...state,
        selected: [],
        choices: [...state.choices, choice],
        categories: state.categories.map(cat => {
          if(cat.code === state.questions[state.currentQuestion].cat) {
            return {
              ...cat,
              score: cat.score + (choice.valid ? 1 : 0),
              total: cat.total + 1
            }
          }
          return cat;
        })
      };
    case TOGGLE_SPLASHSCREEN:
      return {...state, showSplashScreen: !state.showSplashScreen};
    case TOGGLE_COMMENTS:
      // Check if type is equal to "theme" and if solution is already displayed
      if (state.type === TYPE_THEMATIQUE && state.showComments && state.showSolution) {
        return state;
      }
      return {...state, showComments: !state.showComments};
    case TOGGLE_SOLUTION:
      // Check if type is equal to "theme" and if solution is already displayed
      if (state.type === TYPE_THEMATIQUE && state.showComments && state.showSolution) {
        return state;
      }
      return {...state, showSolution: !state.showSolution};
    case TOGGLE_FULLSCREEN:
      return {...state, fullscreen: !state.fullscreen};
    case TOGGLE_IMAGE_FULLSCREEN:
      return {...state, imageFullscreen: !state.imageFullscreen};
    case TOGGLE_SOUND:
      if (state.audio) {
        state.audio.muted = state.sound;
      }
      return {...state, sound: !state.sound};
    case TOGGLE_PAUSE_REJECTED:
      console.log(action.payload);
      break;
    case TOGGLE_PAUSE_FULFILLED:
      return {...state, pause: !state.pause};
    case AUDIO_START:
      return {...state, audio: action.payload};
    case AUDIO_STOP:
      if (state.audio) {
        state.audio.pause();
        return {...state, audio: null};
      }
      break;
    case DISPLAY_AUDIO:
      const displayAudio = action.payload === 'true' || action.payload === '1';
      return {...state, displayAudio: displayAudio, showSplashScreen: displayAudio};
    default:
      break;
  }
  return state;
}

const app = combineReducers({
  exam
});

export default app;
